import { useEffect, useState } from 'react'
import { Plus, FileText, Send, Pencil, Trash2, ArrowUp, ArrowDown } from 'lucide-react'
import Topbar from '../components/Topbar'
import api from '../api/client'
import useAppStore from '../store/appStore'
import { fmtDate } from '../utils/fmt'

export default function Reunioes() {
  const { condominioAtivo } = useAppStore()
  const [reunioes, setReunioes] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(false)
  const [modalAta, setModalAta] = useState(null)
  const [ataTexto, setAtaTexto] = useState('')
  const [convocatoria, setConvocatoria] = useState(null)
  const [editId, setEditId] = useState(null)

  const emptyForm = { data: '', hora: '18:30', local: '', tipo: 'ORDINARIA', ordemTrabalhos: ['Abertura da sessão', 'Aprovação da ata anterior', 'Apresentação de contas', 'Outros assuntos'] }
  const [form, setForm] = useState(emptyForm)
  const [formAta, setFormAta] = useState({ horaInicio: '', horaFim: '', presidente: '', participantes: '', deliberacoes: '', votacoes: '' })
  const [saving, setSaving] = useState(false)
  const [erro, setErro] = useState('')

  const load = () => {
    if (!condominioAtivo) return
    setLoading(true)
    api.get(`/reunioes/${condominioAtivo.id}`).then(r => setReunioes(r.data)).finally(() => setLoading(false))
  }
  useEffect(() => { load() }, [condominioAtivo])

  const openCreate = () => { setForm(emptyForm); setEditId(null); setErro(''); setModal(true) }
  const openEdit = (r) => {
    setForm({
      data: new Date(r.data).toISOString().split('T')[0],
      hora: r.hora, local: r.local, tipo: r.tipo,
      ordemTrabalhos: JSON.parse(r.ordemTrabalhos || '[]')
    })
    setEditId(r.id); setErro(''); setModal(true)
  }

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setErro('')
    try {
      if (editId) await api.put(`/reunioes/${editId}`, { ...form, condominioId: condominioAtivo.id })
      else await api.post('/reunioes', { ...form, condominioId: condominioAtivo.id })
      setModal(false); load()
    } catch (err) { setErro(err.response?.data?.erro || 'Erro.') }
    finally { setSaving(false) }
  }

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminar reunião?')) return
    await api.delete(`/reunioes/${id}`)
    load()
  }

  // Ordem de trabalhos — mover item
  const moverPonto = (i, dir) => {
    const ot = [...form.ordemTrabalhos]
    const j = i + dir
    if (j < 0 || j >= ot.length) return
    ;[ot[i], ot[j]] = [ot[j], ot[i]]
    setForm({ ...form, ordemTrabalhos: ot })
  }

  const handleGerarAta = async (e) => {
    e.preventDefault(); setSaving(true); setErro('')
    try {
      const participantes = formAta.participantes.split(',').map(s => s.trim()).filter(Boolean)
      const deliberacoes = formAta.deliberacoes.split('\n').map(s => s.trim()).filter(Boolean)
      const { data } = await api.put(`/reunioes/${modalAta.id}/ata`, { ...formAta, participantes, deliberacoes, votacoes: [] })
      setAtaTexto(data.ataTexto)
    } catch (err) { setErro(err.response?.data?.erro || 'Erro.') }
    finally { setSaving(false) }
  }

  return (
    <>
      <Topbar title="Reuniões" actions={<button className="btn btn-sm btn-primary" onClick={openCreate}><Plus size={13} /> Nova reunião</button>} />
      <div className="page-content">
        <div className="page-header"><h1>Reuniões e atas</h1><p>Assembleias de condóminos</p></div>
        <div className="card">
          {loading ? <div className="loading-center"><span className="spinner" /></div> : (
            <div className="table-wrap">
              <table className="data-table">
                <thead><tr><th>Data</th><th>Hora</th><th>Tipo</th><th>Local</th><th>Estado</th><th>Ata</th><th></th></tr></thead>
                <tbody>
                  {reunioes.length === 0 ? (
                    <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: 32 }}>Sem reuniões.</td></tr>
                  ) : reunioes.map(r => (
                    <tr key={r.id}>
                      <td>{fmtDate(r.data)}</td>
                      <td>{r.hora}</td>
                      <td><span className={`badge badge-${r.tipo === 'ORDINARIA' ? 'blue' : 'amber'}`}>{r.tipo === 'ORDINARIA' ? 'Ordinária' : 'Extraordinária'}</span></td>
                      <td style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{r.local}</td>
                      <td><span className={`badge badge-${r.estado === 'REALIZADA' ? 'green' : r.estado === 'CANCELADA' ? 'red' : 'amber'}`}>
                        {r.estado === 'REALIZADA' ? 'Realizada' : r.estado === 'CANCELADA' ? 'Cancelada' : 'Agendada'}
                      </span></td>
                      <td>{r.ataAprovada ? <span className="badge badge-green">Aprovada</span> : r.ataTexto ? <span className="badge badge-amber">Rascunho</span> : '—'}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn-sm" onClick={() => openEdit(r)} title="Editar"><Pencil size={12} /></button>
                          <button className="btn btn-sm" title="Ata" onClick={() => {
                            const ot = JSON.parse(r.ordemTrabalhos || '[]')
                            setFormAta({ horaInicio: r.hora, horaFim: '', presidente: r.presidente || '', participantes: JSON.parse(r.participantes || '[]').join(', '), deliberacoes: JSON.parse(r.deliberacoes || '[]').join('\n'), votacoes: '' })
                            setAtaTexto(r.ataTexto || ''); setErro(''); setModalAta(r)
                          }}><FileText size={12} /></button>
                          <button className="btn btn-sm" title="Convocatória" onClick={async () => {
                            const { data } = await api.get(`/reunioes/${r.id}/convocatoria`)
                            setConvocatoria(data.texto)
                          }}><Send size={12} /></button>
                          <button className="btn btn-sm" style={{ color: 'var(--red-dark)' }} onClick={() => handleDelete(r.id)}><Trash2 size={12} /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal criar/editar reunião */}
      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal" style={{ width: 560 }}>
            <div className="modal-header">
              <span className="modal-title">{editId ? 'Editar reunião' : 'Nova reunião'}</span>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 20 }}>×</button>
            </div>
            {erro && <div className="alert alert-error">{erro}</div>}
            <form onSubmit={handleSave}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                <div className="form-group"><label className="form-label">Data *</label><input className="form-input" type="date" value={form.data} onChange={e => setForm({ ...form, data: e.target.value })} required /></div>
                <div className="form-group"><label className="form-label">Hora *</label><input className="form-input" type="time" value={form.hora} onChange={e => setForm({ ...form, hora: e.target.value })} required /></div>
                <div className="form-group"><label className="form-label">Tipo</label>
                  <select className="form-select" value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
                    <option value="ORDINARIA">Ordinária</option><option value="EXTRAORDINARIA">Extraordinária</option>
                  </select>
                </div>
              </div>
              <div className="form-group"><label className="form-label">Local *</label><input className="form-input" value={form.local} onChange={e => setForm({ ...form, local: e.target.value })} required /></div>

              <div className="form-group">
                <label className="form-label">Ordem de trabalhos</label>
                {form.ordemTrabalhos.map((ponto, i) => (
                  <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 12, color: 'var(--text-tertiary)', width: 20 }}>{i + 1}.</span>
                    <input className="form-input" style={{ flex: 1 }} value={ponto}
                      onChange={e => { const ot = [...form.ordemTrabalhos]; ot[i] = e.target.value; setForm({ ...form, ordemTrabalhos: ot }) }} />
                    <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)' }} onClick={() => moverPonto(i, -1)}><ArrowUp size={13} /></button>
                    <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)' }} onClick={() => moverPonto(i, 1)}><ArrowDown size={13} /></button>
                    <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red-dark)' }}
                      onClick={() => { const ot = form.ordemTrabalhos.filter((_, j) => j !== i); setForm({ ...form, ordemTrabalhos: ot }) }}>×</button>
                  </div>
                ))}
                <button type="button" className="btn btn-sm" style={{ marginTop: 4 }}
                  onClick={() => setForm({ ...form, ordemTrabalhos: [...form.ordemTrabalhos, ''] })}>
                  <Plus size={12} /> Adicionar ponto
                </button>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? <span className="spinner" /> : editId ? 'Guardar' : 'Criar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal ata */}
      {modalAta && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModalAta(null)}>
          <div className="modal" style={{ width: 640 }}>
            <div className="modal-header">
              <span className="modal-title">Ata — {fmtDate(modalAta.data)}</span>
              <button onClick={() => setModalAta(null)} style={{ background: 'none', border: 'none', fontSize: 20 }}>×</button>
            </div>
            {!ataTexto ? (
              <>
                {erro && <div className="alert alert-error">{erro}</div>}
                <form onSubmit={handleGerarAta}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                    <div className="form-group"><label className="form-label">Hora início</label><input className="form-input" type="time" value={formAta.horaInicio} onChange={e => setFormAta({ ...formAta, horaInicio: e.target.value })} /></div>
                    <div className="form-group"><label className="form-label">Hora fim</label><input className="form-input" type="time" value={formAta.horaFim} onChange={e => setFormAta({ ...formAta, horaFim: e.target.value })} /></div>
                  </div>
                  <div className="form-group"><label className="form-label">Presidente da mesa</label><input className="form-input" value={formAta.presidente} onChange={e => setFormAta({ ...formAta, presidente: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">Participantes (frações separadas por vírgula)</label><input className="form-input" placeholder="1A, 1B, 2A..." value={formAta.participantes} onChange={e => setFormAta({ ...formAta, participantes: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">Deliberações (uma por linha)</label><textarea className="form-input" rows={4} value={formAta.deliberacoes} onChange={e => setFormAta({ ...formAta, deliberacoes: e.target.value })} /></div>
                  <div className="modal-footer">
                    <button type="button" className="btn" onClick={() => setModalAta(null)}>Cancelar</button>
                    <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? <span className="spinner" /> : 'Gerar ata'}</button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <div className="alert alert-success">Ata gerada. Podes editar antes de copiar.</div>
                <textarea className="form-input" rows={22} value={ataTexto} onChange={e => setAtaTexto(e.target.value)} style={{ fontFamily: 'monospace', fontSize: 12 }} />
                <div className="modal-footer">
                  <button className="btn" onClick={() => setAtaTexto('')}>← Voltar</button>
                  <button className="btn" onClick={() => navigator.clipboard.writeText(ataTexto)}>Copiar</button>
                  <button className="btn btn-primary" onClick={() => setModalAta(null)}>Fechar</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Modal convocatória */}
      {convocatoria && (
        <div className="modal-overlay" onClick={() => setConvocatoria(null)}>
          <div className="modal" style={{ width: 560 }}>
            <div className="modal-header"><span className="modal-title">Convocatória</span><button onClick={() => setConvocatoria(null)} style={{ background: 'none', border: 'none', fontSize: 20 }}>×</button></div>
            <textarea className="form-input" rows={18} value={convocatoria} readOnly style={{ fontFamily: 'monospace', fontSize: 12 }} />
            <div className="modal-footer">
              <button className="btn" onClick={() => navigator.clipboard.writeText(convocatoria)}>Copiar</button>
              <button className="btn btn-primary" onClick={() => setConvocatoria(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
